import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import QrPreview from './QrPreview'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

// The WIFI: QR format requires escaping \, ;, , and : inside field values.
const escapeWifiField = (value) => value.replace(/([\\;,:])/g, '\\$1')

const buildWifiString = ({ ssid, password, encryption, hidden }) =>
  `WIFI:T:${encryption};S:${escapeWifiField(ssid)};` +
  `${encryption === 'nopass' ? '' : `P:${escapeWifiField(password)};`}` +
  `${hidden ? 'H:true;' : ''};`

const WifiQrGenerator = () => {
  useDocumentMeta({
    title: 'Gerador de QR Code para Wi-Fi  jarder.dev',
    description:
      'Gere um QR Code que conecta automaticamente ao seu Wi-Fi  sem ' +
      'precisar digitar a senha. Grátis, direto no navegador.',
  })

  const [ssid, setSsid] = useState('')
  const [password, setPassword] = useState('')
  const [encryption, setEncryption] = useState('WPA')
  const [hidden, setHidden] = useState(false)
  const [value, setValue] = useState('')

  const generate = () => {
    if (!ssid.trim()) return
    setValue(buildWifiString({ ssid, password, encryption, hidden }))
    trackEvent('tool_generate', { tool: 'wifi_qr' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>QR Code de Wi-Fi</h1>
      <p className="tool-disclaimer">
        Gere um QR Code que conecta ao Wi-Fi automaticamente ao ser
        escaneado  nada é enviado para nenhum servidor, tudo fica no seu
        navegador.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="ssid">Nome da rede (SSID)</label>
          <input
            id="ssid"
            type="text"
            value={ssid}
            onChange={(e) => setSsid(e.target.value)}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="encryption">Segurança</label>
          <select
            id="encryption"
            value={encryption}
            onChange={(e) => setEncryption(e.target.value)}
          >
            <option value="WPA">WPA/WPA2</option>
            <option value="WEP">WEP</option>
            <option value="nopass">Sem senha</option>
          </select>
        </div>
      </div>

      {encryption !== 'nopass' && (
        <div className="tool-field">
          <label htmlFor="wifi-password">Senha</label>
          <input
            id="wifi-password"
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      )}

      <div className="tool-field">
        <label>
          <input
            type="checkbox"
            checked={hidden}
            onChange={(e) => setHidden(e.target.checked)}
          />{' '}
          Rede oculta
        </label>
      </div>

      <button
        type="button"
        className="tool-button"
        onClick={generate}
        disabled={!ssid.trim()}
      >
        Gerar QR Code
      </button>

      <QrPreview value={value} filename="wifi-qrcode.png" />

      <div className="tool-info-section">
        <h2>Como funciona</h2>
        <p>
          O QR Code gerado segue o formato padrão de configuração de
          Wi-Fi reconhecido pela câmera do Android e do iPhone: ao
          escanear, o celular já abre a opção de conectar à rede, sem
          precisar digitar a senha manualmente. Prático para deixar
          impresso perto do roteador, em uma placa de recepção ou
          disponível para visitas.
        </p>
      </div>
    </div>
  )
}

export default WifiQrGenerator
